import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useDashboardFilterFields } from './hooks/useDashboardFilterFields';

export const DashboardFilterChips: React.FC = () => {
  const fields = useDashboardFilterFields({ resetDependentOnChange: false });

  return <FilterChips fields={fields} />;
};
